// extracted by mini-css-extract-plugin
export var compactFilters = "_ds-4";
export var detailImage = "_ds-1";
export var dropdownContainer = "_ds-2";
export var imageContainer = "_ds-0";
export var selectedCard = "_ds-3";